import router from "./router/router";
import store from "./store";
import { Message } from "element-ui";
import { getOneKey ,removeOneKey} from '@/utils/auth'

// import { getToken } from "./utils/auth"; // getToken from cookie

/**
 *   该类主要是路由权限控制功能
 *    1、登录后获取token 利用 浏览器seesion 缓存 token
 *    2、 利用token去获取用户信息，以及 路由表 拿到后缓存与vuex
 *    3、 配合vue-router 进行动态路由配置
 *     利用token去获取 用户信息
 *
 */




//白名单
const whiteList = ['/login', '/error','/login/', ];



function getToken(){
    return sessionStorage.getItem("token");
}

/**
 *  talkie-web  也是利用token来做拦截
 *  功能流程描述
 *  1、登录 如果是登录talkie token不会记录在cookie中，如果是登录control会记录token并且记录平台
 *  2 一键登录功能  会请求后台对应终端的token 存放于token中，为了以防当前网页在刷新的时候被挤下去，
 *   新网页拿到 cookice 后会立马销毁存于 session中
 *
 */


router.beforeEach((to, from, next) => {
      /* has no token*/
    // 设置拦截放过 放过login


    let regu = '^/login/';
    let re = new RegExp(regu);
    if(re.test(to.path)){
      next();
      return
    }

   let token = getToken();
  if (token) {

    if (!store.state.token){
      store.commit("SET_TOKEN" ,token);
    }
    // 根目录或者登录会强行跳转到Home
    if (to.path === "/" || to.path === "/login") {
      next({ path: '/home' })
    } else {
      if (store.state.id === undefined ||store.state.id == null ) {  // 依据ID判断是否有用户数据
        store.dispatch("GetUserInfo").then(res => { // 拉取user_info
          // 缺少一个动态路由配置器
          next()
        }).catch((err) => {
          store.dispatch("FedLogOut").then(() => {
            Message.error(err || "Verification failed, please login again");
            next({ path: '/' })
          });
        });
      } else {
        next()
      }
    }
  } else {
      if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next();
    } else {
      next({ path: "/login" }); // 否则全部重定向到登录页
    }
  }
});



// WEBPACK FOOTER //
// ./src/permission.js